// extracted by mini-css-extract-plugin
export default {"multiColumn":"MultiColumn_multiColumn__YD4-p","rightColumn":"MultiColumn_rightColumn__Xf3lA"};